import {
  datePartWithoutTimeYYYYMMDD,
  type BookingDto,
  type DirectionEnum,
  type IApprovalSetBookingConflictAPI,
  type IBulkUpdateBookingsDateTimeDto,
  type IBulkUpdateBookingsDateTimeForm,
  type TimeZoneEnum,
} from "@ryde/shared";

/**
 * A run applies one time to one direction, so a selection spanning both is narrowed to the direction
 * the user picked. The panel says what that leaves out rather than refusing the selection.
 */
export const getBookingIdsForDirection = ({
  bookings,
  direction,
}: {
  bookings: BookingDto[];
  direction: DirectionEnum;
}): number[] =>
  bookings
    .filter(booking => booking.direction === direction)
    .map(({ id }) => id);

export const buildBulkUpdateBookingsDateTimePayload = ({
  bookingIds,
  formValues,
  isPreview,
  approvalBookingConflicts,
  timezone,
}: {
  /** Already narrowed to `formValues.direction` by the panel. */
  bookingIds: number[];
  formValues: IBulkUpdateBookingsDateTimeForm;
  isPreview: boolean;
  approvalBookingConflicts: IApprovalSetBookingConflictAPI[];
  timezone: TimeZoneEnum;
}): IBulkUpdateBookingsDateTimeDto => {
  const { direction, time, date } = formValues;

  const payload: IBulkUpdateBookingsDateTimeDto = {
    bookingIds,
    direction,
    time: time as IBulkUpdateBookingsDateTimeDto["time"],
    // An empty date field is not a value to send: it means every booking keeps its own day.
    date: date ? datePartWithoutTimeYYYYMMDD(date, timezone) : undefined,
    isPreview,
    approvalBookingConflicts,
  };

  return payload;
};
